import React from 'react';
import { ClockIcon, UserIcon } from 'lucide-react';
interface CustomersListProps {
  customers: any[];
  selectedCustomerId: number | null;
  onSelectCustomer: (customer: any) => void;
}
export const CustomersList: React.FC<CustomersListProps> = ({
  customers,
  selectedCustomerId,
  onSelectCustomer
}) => {
  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };
  return <div className="flex-1 overflow-auto" data-id="element-1956">
      {customers.length === 0 ? <div className="flex flex-col items-center justify-center h-full p-6" data-id="element-1957">
          <UserIcon className="h-12 w-12 text-gray-300 mb-2" data-id="element-1958" />
          <p className="text-gray-500" data-id="element-1959">No customers found</p>
        </div> : <ul className="divide-y divide-gray-200" data-id="element-1960">
          {customers.map(customer => <li key={customer.id} className={`cursor-pointer hover:bg-gray-50 transition-colors ${selectedCustomerId === customer.id ? 'bg-blue-50' : ''}`} onClick={() => onSelectCustomer(customer)} data-id="element-1961">
              <div className="p-4" data-id="element-1962">
                <div className="flex justify-between items-start" data-id="element-1963">
                  <div className="flex items-center" data-id="element-1964">
                    <div className="flex-shrink-0 h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 font-medium" data-id="element-1965">
                      {customer.firstName.charAt(0)}
                      {customer.lastName.charAt(0)}
                    </div>
                    <div className="ml-3" data-id="element-1966">
                      <p className="text-sm font-medium text-gray-900" data-id="element-1967">
                        {customer.firstName} {customer.lastName}
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-1968">{customer.email}</p>
                    </div>
                  </div>
                  <div className={`text-xs px-2 py-1 rounded-full ${customer.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`} data-id="element-1969">
                    {customer.status.charAt(0).toUpperCase() + customer.status.slice(1)}
                  </div>
                </div>
                <div className="mt-2 flex items-center text-xs text-gray-500" data-id="element-1970">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-1971" />
                  <span data-id="element-1972">Last contact: {formatDate(customer.lastContact)}</span>
                </div>
                {customer.upcomingTrip && <div className="mt-1 text-xs text-blue-600" data-id="element-1973">
                    Upcoming: {customer.upcomingTrip}
                  </div>}
                {customer.tags.length > 0 && <div className="mt-2 flex flex-wrap gap-1" data-id="element-1974">
                    {customer.tags.slice(0, 3).map((tag: string) => <span key={tag} className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800" data-id="element-1975">
                        {tag}
                      </span>)}
                    {customer.tags.length > 3 && <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-800" data-id="element-1976">
                        +{customer.tags.length - 3}
                      </span>}
                  </div>}
              </div>
            </li>)}
        </ul>}
    </div>;
};